exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mx-input{border:1px solid #28a745;color:#495057}.mx-input:focus,.mx-input:hover{border-color:#28a745}.mx-input:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.mx-icon-calendar{color:#28a745}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c69869a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/video/Form.vue
// module id = 970
// module chunks = 0